export const margin = {
  x: 80,
  y: 30
}
